export default __webpack_public_path__ + "static/media/layout-section.6f497534.png";